<template>
    <div class="home h-100">
        <div class="container d-flex h-100">
            <div style="width: 100%">
                <div class="row justify-content-center pb-3">
                    <div class="col-md-6">
                        <h1 class="text-center pb-3 mt-0">
                            Do you know your child's speech milestones?
                        </h1>
                        <div class="d-flex justify-content-center">
                            <router-link to="/screener/basics/name" class="btn btn-purple btn-lg">
                                Get started
                            </router-link>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="d-none justify-content-center pt-5 d-md-flex flex-wrap">
                            <div class="pl-3 pr-3 pb-2">
                                <img src="https://cdn.speechblubs.com/2020/08/xceptional-ed-logo-white@2x.png"
                                     style="height: 31px;">
                            </div>
                            <div class="pl-3 pr-3 pb-2">
                                <img src="https://cdn.speechblubs.com/2020/08/vogue-logo-white@2x.png"
                                     style="height: 23px;">
                            </div>
                            <div class="pl-3 pr-3 pb-2">
                                <img src="https://cdn.speechblubs.com/2020/08/brisbane-white@2x.png"
                                     style="height: 23px;">
                            </div>
                            <div class="pl-3 pr-3 pb-2">
                                <img src="https://cdn.speechblubs.com/2020/08/wired@2x.png" style="height: 21px;">
                            </div>
                            <div class="pl-3 pr-3 pb-2">
                                <img src="https://cdn.speechblubs.com/2020/08/autism-parenting-white@2x.png"
                                     style="height: 22px;">
                            </div>
                            <div class="pl-3 pr-3 pb-2">
                                <img src="https://cdn.speechblubs.com/2020/08/forbes-logo-white@2x.png"
                                     style="height: 20px;">
                            </div>
                            <div class="pl-3 pr-3 pb-2">
                                <img src="https://cdn.speechblubs.com/2020/08/bilingual@2x.png" style="height: 28px;">
                            </div>
                        </div>
                        <div class="d-block d-md-none pt-4" style="width: calc(100% - 60px); margin: 0 auto">
                            <div class="owl owl-carousel" id="carousel">
                                <div class="item">
                                    <img src="https://cdn.speechblubs.com/2020/08/xceptional-ed-logo-white@2x.png" style="width: 100%">
                                </div>
                                <div class="item">
                                    <img src="https://cdn.speechblubs.com/2020/08/vogue-logo-white@2x.png" style="width: 100%">
                                </div>
                                <div class="item">
                                    <img src="https://cdn.speechblubs.com/2020/08/brisbane-white@2x.png" style="width: 100%">
                                </div>
                                <div class="item">
                                    <img src="https://cdn.speechblubs.com/2020/08/wired@2x.png" style="width: 100%">
                                </div>
                                <div class="item">
                                    <img src="https://cdn.speechblubs.com/2020/08/autism-parenting-white@2x.png" style="width: 100%">
                                </div>
                                <div class="item">
                                    <img src="https://cdn.speechblubs.com/2020/08/forbes-logo-white@2x.png" style="width: 100%">
                                </div>
                                <div class="item">
                                    <img src="https://cdn.speechblubs.com/2020/08/bilingual@2x.png" style="width: 100%">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'gtm-screener-landing-page-view'
            });
            setTimeout(() => {
                $('#carousel').owlCarousel({
                    loop: true,
                    nav: true,
                    dots: false,
                    margin: 15,
                    items: 3,
                })
            }, 500);
        },
        methods: {
        }
    }
</script>

<style lang="less" scoped>
    .home {
        background: url('https://cdn.speechblubs.com/2020/08/shutterstock-655726294.jpg') no-repeat center/cover;
        color: #3c32a0;

        .container {
            align-items: center;
            @media (max-width: 768px) {
                align-items: flex-end;
            }
            .col {
                margin: auto;
                max-width: 800px;
            }

            h1 {
                font-size: 32px;
                line-height: 48px;
                color: #1e1e1e;
                margin: 50px 0 15px;
                font-weight: bold;
                @media (max-width: 991px) {
                    font-size: 24px;
                    line-height: 28px;
                }
            }
        }
        @media (max-width: 768px) {
            background: url('https://cdn.speechblubs.com/2020/08/shutterstock-655726294@2x.png') no-repeat center/cover;
        }
    }
</style>
